import type React from "react";

import { useIntercom } from "src/hooks/useIntercom";

import { SideMenuLayout } from "../SideMenuLayout/SideMenuLayout";

interface SimpleViewLayoutProps {
    children?: React.ReactNode;
}

const SimpleViewLayout: React.FC<SimpleViewLayoutProps> = ({ children }) => {
    useIntercom();

    return <SideMenuLayout>{children}</SideMenuLayout>;
};

export default SimpleViewLayout;
